import { createSlice } from "@reduxjs/toolkit";
import { fetchHeatData, fetchHeatDetails } from "./deviceConfigThunk";

const deviceConfigSlice = createSlice({
  name: "deviceConfig",
  initialState: {
    heatData: null,
    heatDetails: null,
    deviceData: false,
    loading: false,
    error: null,
  },
  reducers: {
    setDeviceData: (state, action) => {
      state.deviceData = action.payload;
    },
    clearDeviceConfigState: (state) => {
      state.heatData = null;
      state.heatDetails = null;
      state.deviceData = false;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchHeatData
      .addCase(fetchHeatData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHeatData.fulfilled, (state, action) => {
        state.loading = false;
        state.heatData = action.payload;
      })
      .addCase(fetchHeatData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchHeatDetails
      .addCase(fetchHeatDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHeatDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.heatDetails = action.payload;
      })
      .addCase(fetchHeatDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDeviceConfigState , setDeviceData} = deviceConfigSlice.actions;
export default deviceConfigSlice.reducer;
